import { coupangReviewFailuresInstance } from './instance';
import type {
  CoupangReviewFailuresResponse,
  CoupangReviewState,
  VerifyCoupangReviewFailureRequest,
  VerifyCoupangReviewFailureResponse,
} from './types';

export const fetchCoupangReviewFailures = async (params: {
  state: CoupangReviewState;
  limit: number;
  cursor?: string;
}): Promise<CoupangReviewFailuresResponse> => {
  const response = await coupangReviewFailuresInstance.get<CoupangReviewFailuresResponse>(
    '/products/admin/coupangReviewFailures',
    {
      params: {
        state: params.state,
        limit: params.limit,
        cursor: params.cursor,
      },
    },
  );
  return response.data;
};

export const verifyCoupangReviewFailure = async (
  productId: number,
  request: VerifyCoupangReviewFailureRequest,
): Promise<VerifyCoupangReviewFailureResponse> => {
  const response = await coupangReviewFailuresInstance.patch<VerifyCoupangReviewFailureResponse>(
    `/products/admin/coupangReviewFailures/${encodeURIComponent(String(productId))}/verify`,
    request,
  );
  return response.data;
};
